// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {isClaimSystemSelected, isClaimUserSelected} from '../services/is-claim-in-audit';
import AuditClaim from '@deere/cps-it.warranty-model-factory/lib/audit-claim';
import ClaimResult from './claim-result';
import {FormattedMessage} from 'react-intl';
import ListViewShowMore from '../../../shared/components/list-view-show-more';

const ClaimsList = props =>
    <section className='claims-list'>
        <ListViewShowMore
            initialShowItems={50}
            perMoreMultiplier={1.25}
            showAllOption={true}
            showPerMore={50}
            totalItems={props.claims.length}
        >
            {props.claims.map(claim =>
                isClaimSystemSelected(claim.claimNumber, props.auditClaims) ?
                    null :
                    <ClaimResult
                        handleAddClaim={props.handleAddClaim.bind(null, claim)}
                        handleRemoveClaim={props.handleRemoveClaim.bind(null, claim)}
                        isClaimInAudit={isClaimUserSelected(claim.claimNumber, props.auditClaims)}
                        item={claim}
                        key={claim.claimNumber}
                    />)
            }
        </ListViewShowMore>
        {(!props.claims.length && !props.isInitialLoad) ?
            <span className='empty'>
                <FormattedMessage id='NO_RESULTS_FOUND'/>
            </span> :
            null
        }
    </section>;

ClaimsList.displayName = 'ClaimsList';
ClaimsList.propTypes = {
    auditClaims: PropTypes.arrayOf(PropTypes.instanceOf(AuditClaim)).isRequired,
    claims: PropTypes.arrayOf(PropTypes.instanceOf(AuditClaim)).isRequired,
    handleAddClaim: PropTypes.func.isRequired,
    handleRemoveClaim: PropTypes.func.isRequired,
    isInitialLoad: PropTypes.bool.isRequired
};

export default ClaimsList;



// WEBPACK FOOTER //
// ./src/tcsm/claim-search/components/claims-list.js